import clsx from 'clsx'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import type { FC } from 'react'

interface HelpBlockProps extends React.HTMLAttributes<HTMLDivElement> {}

const HelpBlock: FC<HelpBlockProps> = ({ className }) => {
  return (
    <div
      className={clsx(
        'bg-white rounded-lg p-3 flex space-x-3 items-center',
        className
      )}
    >
      <Icon as="i" color="inherit">
        info_outlined
      </Icon>
      <Text variant="body">
        Jika terjadi kendala, kunjungi Pusat Bantuan melalui{' '}
        <a
          className="text-blue-70 hover:underline"
          target="_blank"
          href="https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/17265347384217-Kendala-Pelaksanaan-Uji-Kompetensi-Perpindahan-ke-dalam-JF-Guru"
          rel="noopener noreferrer"
        >
          tautan ini
        </a>
        .
      </Text>
    </div>
  )
}
export default HelpBlock
